import { queryOptions, useQuery } from '@tanstack/react-query';
import { TrainRecordingService } from '../generated';
import { blobToDataURL } from '../common';
import { ApiError } from '../../components/ApiLoadingGuard/ApiLoadingGuard';

export interface WagonNumberImageProps {
  jobsiteId: string;
  recordingId: string;
}

export async function fetchWagonNumberImageDataURL({ jobsiteId, recordingId }: WagonNumberImageProps): Promise<string> {
  const response = await TrainRecordingService.trainRecordingControllerGetWagonNumberImage({
    path: {
      jobsiteId,
      recordingId,
    },
  });

  if (response.data !== undefined) {
    return await blobToDataURL(response.data as Blob);
  }

  throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
}

export interface WagonNumberImageOptionsProps {
  jobsiteId: string | undefined;
  recordingId: string | undefined;
  enabled?: boolean;
}

export function wagonNumberImageOptions({ jobsiteId, recordingId, enabled = true }: WagonNumberImageOptionsProps) {
  return queryOptions<string, ApiError>({
    queryKey: ['wagonNumberImage', jobsiteId, recordingId],
    queryFn: async () => {
      if (!jobsiteId || !recordingId) {
        throw new Error('jobsiteId and recordingId are required');
      }

      return await fetchWagonNumberImageDataURL({ jobsiteId, recordingId });
    },
    enabled: !!jobsiteId && !!recordingId && enabled,
  });
}

export function useWagonNumberImage(props: WagonNumberImageOptionsProps) {
  return useQuery(wagonNumberImageOptions(props));
}
